import { useContext } from 'react';
import { Context } from '../contexts/Toolbelt/index.ts';

export const useToolbelt = () => useContext(Context);
